<template>
    <div>
      <slot />
                </div>
</template>
<script>

import { mapState } from 'vuex'
export default {

	name: 'LayoutFichaCliente',
	components: {
	},
	mounted () {
		const plugin = document.createElement('script')
		plugin.setAttribute(
			'src',
			'https://kit.fontawesome.com/c1b864fb23.js'
		)
		document.head.appendChild(plugin)
	},
	computed: {
		...mapState([''])
	}
}

</script>
<style>
#content-body {
  background-image: none;
  background-color: #ffffff;
  color:black;
}
</style>



// WEBPACK FOOTER //
// src/components/LayoutFichaCliente.vue